export function getCookieValue(name: string): string | null {
  let cookies = document.cookie.split("; ");
  let value = cookies.find((cookie) => cookie.startsWith(name + "="));
  return value ? decodeURIComponent(value.split("=")[1]) : null;
}

export function setCookie(key: string, value: string, days: number) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${key}=${value};${expires};path=/`;
}

export function removeSSOToken() {
  // Function to remove the cookie
  function removeCookie(domain: string) {
    document.cookie = `token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain}`;
  }

  // Get the current domain
  const currentDomain = window.location.hostname;

  // Remove the cookie for the current domain
  removeCookie(currentDomain);

  // Try to remove the cookie for the parent domain
  const domainParts = currentDomain.split(".");
  if (domainParts.length > 2) {
    const parentDomain = domainParts.slice(1).join(".");
    removeCookie(parentDomain);
  }
}
